export default __webpack_public_path__ + "static/img_bubbles_onetokens-194b22f77b4edc620f77560b5224b6a5.svg";